import axios from 'axios';


//正式服
let base = 'https://admin-dist-api.y7y.net/';

//beta服
//let base = 'https://beta-dist-api.y7y.net/';

export const baseUrl = base ;
//登录 
export const slogin = params => { return axios.post(`${base}user/login`, params).then(res => res.data); };
//上传图片 
export const supload = (token) => { return axios.post(`${base}user/upload`,{ 
    headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'token':token
            }
}).then(res => res.data); };
//用户菜单 
export const smenu = (token) => { return axios.get(`${base}user/menu?from=32`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//用户配置 
export const sconfig = (token) => { return axios.get(`${base}setting/index`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };



//整体数据列表 
export const getTotalData = (p,token) => { return axios.get(`${base}mainData/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//整体数据列表 for Day
export const getTotalDataDay = (p,token) => { return axios.get(`${base}mainData/day?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//整体数据详情
export const getDetailData = (p,token) => { return axios.get(`${base}mainData/detail?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//整体数据更多详情
export const getMoreDetail = (p,token) => { return axios.get(`${base}mainData/creative&${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };



//基础数据列表 
export const getBasicData = (p,token) => { return axios.get(`${base}baseData/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//基础数据访问分析
export const getBasiVisit = (p,token) => { return axios.get(`${base}baseData/trend?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//基础数据来源分析
export const getBasiFrom = (p,token) => { return axios.get(`${base}baseData/distribution?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//基础数据用户画像
export const getBasiUser = (p,token) => { return axios.get(`${base}baseData/user?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//渠道管理 - 列表
//export const getChannelList = (p,token) => { return axios.get(`${base}issuedChannel/index?${p}`,{ 
//  headers: {
//              'Content-Type': 'application/json',
//              'token':token
//          }
//}).then(res => res.data); };
//渠道管理 - 阿拉丁列表
export const getChannelList = (p,token) => { return axios.get(`${base}IssuedAldChannel/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//渠道管理 - 通知下线功能
export const notifyOff = (p,token) => { return axios.post(`${base}IssuedAldChannel/status`,p,{
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//渠道管理 - 增加
//export const getChannelAdd = (p,token) => { return axios.post(`${base}issuedChannel/add`,p,{ 
//  headers: {
//              'Content-Type': 'application/json',
//              'token':token
//          }
//}).then(res => res.data); };
//渠道管理 - 阿拉丁增加
export const getChannelAdd = (p,token) => { return axios.post(`${base}IssuedAldChannel/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//渠道管理 - 编辑
//export const getChannelEdit = (p,token) => { return axios.post(`${base}issuedChannel/edit`,p,{ 
//  headers: {
//              'Content-Type': 'application/json',
//              'token':token
//          }
//}).then(res => res.data); };

//渠道管理 - 阿拉丁编辑
export const getChannelEdit = (p,token) => { return axios.post(`${base}IssuedAldChannel/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//渠道管理 - 状态
//export const getChannelStatus = (p,token) => { return axios.post(`${base}issuedChannel/status`,p,{ 
//  headers: {
//              'Content-Type': 'application/json',
//              'token':token
//          }
//}).then(res => res.data); };
//渠道管理 - 阿拉丁状态
export const getChannelStatus = (p,token) => { return axios.post(`${base}IssuedAldChannel/status`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//渠道分析 - 列表
//export const getCFXList = (p,token) => { return axios.get(`${base}issuedChannelData/index?${p}`,{ 
//  headers: {
//              'Content-Type': 'application/json',
//              'token':token
//          }
//}).then(res => res.data); };
//数据分析列表 - 阿拉丁列表
export const getCFXList = (p,token) => { return axios.get(`${base}IssuedAldData/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//渠道数据分析列表 - 阿拉丁列表
export const getCFXDataList = (p,token) => { return axios.get(`${base}IssuedAldChannelData/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//渠道数据分析列表详情 - 阿拉丁列表
export const getCFXDataListDetail = (p,token) => { return axios.get(`${base}IssuedAldChannelData/detail?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//渠道分析 - 更新买量支出
export const getChannelUpdate = (p,token) => { return axios.post(`${base}issuedChannelData/update`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//账号管理 - 列表
export const getPlist = (p,token) => { return axios.get(`${base}issuedApp/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//账号管理 - 增加
export const getPAdd = (p,token) => { return axios.post(`${base}issuedApp/add`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//账号管理 - 编辑
export const getPEdit = (p,token) => { return axios.post(`${base}issuedApp/edit`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//账号管理 - 状态
export const getPStatus = (p,token) => { return axios.post(`${base}issuedApp/status`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//渠道小程序列表
export const getAppid = (p,token) => { return axios.get(`${base}app/index?kw=${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//修改密码
export const scpwd = (p,token) => { return axios.post(`${base}user/password`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//买量更新
export const updateBuy = (p,token) => { return axios.post(`${base}MainData/cost`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//买量详情
// issued_app_id=1&sdate=20190701&edate=20190701
export const buyDetail = (p,token) => { return axios.get(`${base}MainData/cost&${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//产品列表
export const getIssuedAppList = (p,token) => { return axios.get(`${base}issuedApp/select?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//产品渠道列表
export const getIssuedAldChanneList = (p,token) => { return axios.get(`${base}IssuedAldChannel/select?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//采集整体数据
export const getPython =(p,token) => { return axios.get(`${base}python/?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//渠道管理-批量增加

export const batchAdd = (p,token) => { return axios.post(`${base}IssuedAldChannel/batch`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//整体数据 - 产品日报
export const getProductDaily =(p,token) => { return axios.get(`${base}productDaily/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//整体数据 - 产品日报详情
export const getProductDailyDetail =(p,token) => { return axios.get(`${base}productDaily/detail?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//整体数据 - 收入日报
export const getIncomeDaily =(p,token) => { return axios.get(`${base}incomeDaily/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//整体数据 - 收入日报-详情
export const getIncomeDailyDetail =(p,token) => { return axios.get(`${base}incomeDaily/detail?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//成本日报
export const getcostDaily =(p,token) => { return axios.get(`${base}costDaily/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };



//成本日报 按天
export const getcostDailyForDays =(p,token) => { return axios.get(`${base}costDaily/day?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//成本日报 详情

export const getcostDailyDetail =(p,token) => { return axios.get(`${base}costDaily/detail?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

export const getcostDailyDetailForDays =(p,token) => { return axios.get(`${base}costDaily/dday?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//costDaily/detail

//成本日报 详情 更新成本
export const updateCost =(p,token) => { return axios.post(`${base}costDaily/color`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}).then(res => res.data); };

//成本日报 详情 确认下线功能
export const confirmOff = (p,token) => { return axios.post(`${base}IssuedAldChannel/status`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}).then(res => res.data); };

//编辑获客单价
export const AtvEdit = (p,token) => { return axios.post(`${base}IssuedAldChannelData/atv`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//编辑渠道扣量
export const PostChannelDiscount = (p,token) => { return axios.post(`${base}IssuedAldChannelData/pr`,p,{
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//筛选公司
export const selectCompany =(p,token) => { return axios.get(`${base}issuedAldChannel/company?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


// 成本日报 - 修改

export const visitUVNewEdit =(p,token) => { return axios.post(`${base}costDaily/update`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//成本日志
export const getLogCost =(p,token) => { return axios.get(`${base}log/cost?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

export const selectUser  =(p,token) => { return axios.get(`${base}user/select?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

export const selectC  =(p,token) => { return axios.get(`${base}log/select?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//扣量日报
export const getExchangeDaily  =(p,token) => { return axios.get(`${base}exchange/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//扣量日报按天
export const getExchangeDailyDay  =(p,token) => { return axios.get(`${base}exchange/day?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//扣量日报详情
export const getExchangeDailyDetail  =(p,token) => { return axios.get(`${base}exchange/detail?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//扣量日报详情按天
export const getExchangeDailyDetailDay  =(p,token) => { return axios.get(`${base}exchange/dday?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//扣量公司筛选
export const getExchangeCompany  =(p,token) => { return axios.get(`${base}exchange/company?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//扣量公司筛选（带权限）
export const getIssuedAldCompany  =(p,token) => { return axios.get(`${base}issuedAldChannel/companys?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//扣量产品筛选
export const getExchangeApp  =(p,token) => { return axios.get(`${base}exchange/app?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//扣量日本产品编辑
export const exchangeDailyEdit =(p,token) => { return axios.post(`${base}exchange/update`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };



//渠道分析数据导入
export const importAldChannelData = (p,token)=> { return axios.post(`${base}issuedAldChannelData/import`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}); };

//成本账单列表
export const getBillDataList  =(p,token) => { return axios.get(`${base}billIssuedData/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//生成账单
export const billDataAdd = (p,token)=> { return axios.post(`${base}billIssuedData/build`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}).then(res => res.data); };

//账单状态
export const billDataStatus = (p,token)=> { return axios.post(`${base}billIssuedData/status`,p,{
    headers: {
        'Content-Type': 'application/json',
        'token':token
    }
}).then(res => res.data); };

//成本账单详情
export const getBillDataDetail  =(p,token) => { return axios.get(`${base}billIssuedData/detail?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


export const sclog = (p,token) => { return axios.get(`${base}log/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//成本账单列表
export const getCPBillDataList  =(p,token) => { return axios.get(`${base}billCpData/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//分成账单导入
export const batchCPAdd = (p,token) => { return axios.post(`${base}billCpData/import`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//编辑分成列表
export const CPEdit = (p,token) => { return axios.post(`${base}billCpData/edit`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//分成公司筛选列表
export const getCPCompanyList  =(p,token) => { return axios.get(`${base}cpCompany/select?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//分成列表备注
export const CPRemark = (p,token) => { return axios.post(`${base}billCpData/remark`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//分成汇总列表
export const getbillCpDataSummary  =(p,token) => { return axios.get(`${base}billCpData/summary?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//分成汇总列表详情
export const getbillCpDatasummaryDetail  =(p,token) => { return axios.get(`${base}/billCpData/summaryDetail?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//

export const getfieldFilter  =(p,token) => { return axios.get(`${base}user/fieldFilter?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

export const postfieldFilter = (p,token) => { return axios.post(`${base}user/fieldFilter`,p,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

export const getValidProductPlatform  =(p,token) => { return axios.get(`${base}user/validProductPlatform?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };



//广点通渠道回收导入
export const batchGDTAddTF = (p,token) => { return axios.post(`${base}/issuedAldChannelGdt/batchTf`,p,{
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//广点通渠道回收导入
export const batchGDTAddFX = (p,token) => { return axios.post(`${base}/issuedAldChannelGdt/batchFx`,p,{
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//广点通渠道回收列表
export const getGDBackTList  =(p,token) => { return axios.get(`${base}/issuedAldChannelGdt/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };

//广点通渠道回收列表-渠道
export const getGDBackTListChannel  =(p,token) => { return axios.get(`${base}/issuedAldChannelGdt/channel?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };
//广点通渠道回收列表-渠道-日期
export const getGDBackTListChannelDate  =(p,token) => { return axios.get(`${base}/issuedAldChannelGdt/date?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


//数据概览
export const getSummaryIndex  =(p,token) => { return axios.get(`${base}summary/index?${p}`,{ 
    headers: {
                'Content-Type': 'application/json',
                'token':token
            }
}).then(res => res.data); };


// WEBPACK FOOTER //
// ./src/api/api.js